import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { toast } from "react-toastify";
import { residenceClientAssignment, getTeamCaseload } from "../services/soar";
import ExpandDiv from "../common/ExpandDiv";
import FloatingInput from "../common/FloatingInput";

function ClientHistory({ data, refreshData }) {
  const navigate = useNavigate();
  const [placementData, setPlacementData] = useState({});
  const [clients, setClients] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    getClients();
  }, [data.programUnitName]);

  const getClients = async () => {
    if (data.programUnitName) {
      const resp = await getTeamCaseload([
        data.programUnitName.split(" - ")[0],
      ]);
      const clients = resp
        .filter(
          (c) => c["unit.ccx_programtype"]["@name"] === "Independent Living"
        )
        .map((c) => ({
          _id: c.ccx_patient["#text"].toUpperCase().replace(/[{}]/g, ""),
          name: c.ccx_patient["@name"],
          clientProgram: c.ccx_client_programid
            .toUpperCase()
            .replace(/[{}]/g, ""),
        }));
      setClients(clients);
    }
  };

  const clearPlacementData = () => {
    setPlacementData({
      client: "",
      admission: "",
      discharge: "",
    });
  };

  const savePlacement = async () => {
    let body = {
      command: placementData.id ? "update" : "insert",
      application: data.application,
      residence: data.id,
      client: placementData.client,
      clientName: clients.find((c) => c._id === placementData.client)?.name,
      admission: placementData.admission,
      discharge: placementData.discharge,
      clientProgram: clients.find((c) => c._id === placementData.client)
        ?.clientProgram,
      //   serviceStatus: "NA",
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };

    if (placementData.id) {
      body.id = placementData.id;
    }

    const response = await residenceClientAssignment(body);
    if (response.code === "success") {
      toast.success(
        `Placement ${body.id ? "Updated" : "Created"} Successfully`
      );
      setShow(false);
      clearPlacementData();
      refreshData();
    } else {
      console.log("Error Response", response);
      toast.error(
        `Error ${body.id ? "Updating" : "Creating"} Placement. ${
          response.message
        }`
      );
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          clearPlacementData();
        }}
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Utility Information</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-safy2-4">
          <FloatingInput
            type="select"
            className="card-safy mb-2"
            label={<div className="text-danger">Client</div>}
            name="client"
            value={placementData.client}
            options={clients}
            onChange={(e) => {
              setPlacementData({ ...placementData, client: e.target.value });
            }}
          />
          <FloatingInput
            type="date"
            className="card-safy my-2"
            label={<div className="text-danger">Admission Date</div>}
            name="admission"
            value={placementData.admission}
            onChange={(e) =>
              setPlacementData({ ...placementData, admission: e.target.value })
            }
          />
          <FloatingInput
            type="date"
            className="card-safy mb-2"
            label="Discharge Date"
            name="discharge"
            value={placementData.discharge}
            onChange={(e) =>
              setPlacementData({ ...placementData, discharge: e.target.value })
            }
          />
        </Modal.Body>
        <Modal.Footer className="bg-safy2-4">
          <div
            className="btn btn-sm btn-success"
            onClick={() => {
              savePlacement();
            }}
          >
            Save
          </div>
          <div
            className="btn btn-sm btn-danger"
            onClick={() => {
              clearPlacementData();
              setShow(false);
            }}
          >
            Cancel
          </div>
        </Modal.Footer>
      </Modal>
      <ExpandDiv
        title="Client History"
        className={`border p-2 mb-2 card-safy`}
        expandStatus={true}
      >
        <div className="row">
          <div className="col-11"></div>
          <div className="col-1">
            <i
              className="fas fa-plus-circle fa-xl text-primary float-end me-2 mb-2"
              role="button"
              onClick={() => {
                clearPlacementData();
                setShow(true);
              }}
            ></i>
          </div>
        </div>
        <div>
          {data.clientHistory?.map((client, chindex) => (
            <div
              key={`client-${chindex}`}
              className="row border border-dark bg-safy2-4 m-2 p-2"
            >
              <div className="col-3 fw-bold">
                <div
                  className="btn btn-sm btn-primary border border-dark"
                  onClick={() => navigate(`/client/${client.client}`)}
                >
                  {client.clientName}
                </div>
              </div>
              <div className="col-1 fw-bold">Start</div>
              <div className="col-2">
                {client.admission
                  ? moment(client.admission).format("MM/DD/YYYY")
                  : null}
              </div>
              <div className="col-1 fw-bold">End</div>
              <div className="col-2">
                {client.discharge
                  ? moment(client.discharge).format("MM/DD/YYYY")
                  : null}
              </div>
              <div className="col-3">
                <i
                  className="fas fa-pen text-primary float-end"
                  role="button"
                  onClick={() => {
                    setPlacementData({
                      id: client.id,
                      client: client.client.toUpperCase(),
                      admission: client.admission,
                      discharge: client.discharge,
                    });
                    setShow(true);
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </ExpandDiv>
    </>
  );
}

export default ClientHistory;
